import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "../../components/Button";
import Card from "../../components/Card";
import Input from "../../components/Input";
import { api } from "../../services/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const navigate = useNavigate();

  const isEmailValid = /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      const res = await api.post("/auth/forgot-password", { email });
      await Swal.fire(
        "Success",
        res.message || "Password reset link sent!",
        "success"
      );
      setStatus("success");
      navigate("/login");
    } catch (err) {
      setStatus("error");
      await Swal.fire(
        "Error",
        err.error || "An error occurred. Please try again.",
        "error"
      );
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-text">
          Reset your password
        </h2>
        <p className="mt-2 text-center text-sm text-text opacity-80">
          Enter your email address and we'll send you a link to reset your
          password.
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card className="py-8 px-4 sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <Input
              label="Email address"
              type="email"
              id="email"
              name="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              type="submit"
              loading={status === "loading"}
              className="w-full"
              disabled={!isEmailValid || status === "loading"}
            >
              Send reset link
            </Button>
          </form>
          <div className="mt-6 text-center">
            <Link
              to="/login"
              className="font-medium text-primary hover:opacity-80"
            >
              Return to login
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
